import {
  Component,
  OnInit,
  ViewChild,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AgenciaService } from "../../servicios/agencia.service";
import { Utils } from "../../utils/utils";
import { UsuarioService } from "../../servicios/usuario.service";
import { MatDialog } from "@angular/material/dialog";
import { Observable, Subject } from "rxjs";
import * as _moment from "moment";
import * as XLSX from "xlsx";
import * as chart from "chart.js";
import * as _ from "underscore";

import { DataTableDirective } from "angular-datatables";
import { DialogDetallePedidoComponent } from "../../dialogs/dialog-detalle-pedido/dialog-detalle-pedido.component";

import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { startWith, map } from "rxjs/operators";
import { InformeRecorridoService } from "../../servicios/informes/informe-recorrido.service";
import { ColorsService } from "../../servicios/colors.service";

export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DD",
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "YYYY-MM-DD",
    dateA11yLabel: "YYYY-MM-DD",
    monthYearA11yLabel: "YYYY-MM-DD",
  },
};

export interface Usuario {
  id: string;
  valor: string;
}

@Component({
  selector: "app-informe-recorrido-vendedor",
  templateUrl: "./informe-recorrido-vendedor.component.html",
  styleUrls: ["./informe-recorrido-vendedor.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class InformeRecorridoVendedorComponent implements OnInit {
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  ventasGroup: FormGroup;
  loadingAgencias = false;
  loadingUsuarios = false;
  loading = false;
  usuarioConsulta = "";
  filteredUsuarios: Observable<Usuario[]>;
  agencias = [];
  usuarios = [];
  dataRecorrido = [];
  haveData = false;
  timeRunning = 0;
  alternate: boolean = false;
  isExpanded: boolean = false;
  mostrarIcono: boolean = true;
  searchForm: FormGroup;
  mostrarTimeLine = 4;

  recorridoPie: any;
  recorridoBar: any;

  dtTrigger: Subject<any>[] = [];

  dtOptions: any = {
    pagingType: "full_numbers",
    scrollX: true,
    dom: "Bfrtip",
    order: [],
    buttons: [
      "colvis",
      {
        extend: "copyHtml5",

        exportOptions: {
          columns: ":visible",
        },
      },
      {
        extend: "excelHtml5",
        fileName: "ResumenRecorrido" + ".xlsx",
        exportOptions: {
          columns: ":visible",
        },
        //CharSet: "utf8",
        exportData: { decodeEntities: true },
      },
    ],
  };

  valoresResumen = [];
  novedades = [];
  totalVenta = 0;
  totalNovedades=0;

  constructor(
    private fb: FormBuilder,
    private servicioAgencia: AgenciaService,
    private serviceUsuario: UsuarioService,
    private servicioRecorridoVendedor: InformeRecorridoService,
    private servicioColores: ColorsService,
    public ruta: Utils,
    private dialog: MatDialog
  ) {
    this.ventasGroup = this.fb.group({
      idAgencia: ["", Validators.required],
      usuarioCtrl: ["", Validators.required],
      fechaInicial: [new Date(), Validators.required],
      fechaFinal: [new Date(), Validators.required],
    });

    this.searchForm = this.fb.group({
      searchText: [""],
    });

    const fechaHoy = new Date();
    const nFecha = _moment(fechaHoy, "YYYY-MM-DD").format("YYYY-MM-DD");
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    this.usuarioConsulta = infoUsuario[0].IdUsuario;
    this.loadingAgencias = true;
    this.servicioAgencia
      .getAgencia(infoUsuario[0].IdUsuario, 0)
      .subscribe((result) => {
        this.agencias = result;
        this.agencias.unshift({
          id: "0",
          valor: "TODOS",
        });
        this.ventasGroup.controls["idAgencia"].setValue("0");
        this.loadingAgencias = false;
        this.ventasGroup.get("idAgencia").valueChanges.subscribe((value) => {
          this.cargarUsuariosAgencia();
        });
        //console.log(this.agencias);
      });

    this.loadingUsuarios = true;
    this.serviceUsuario
      .getUsuariosPersonas(3, infoUsuario[0].IdUsuario, 0, 0) //3 para tipo usuario vendedor
      .subscribe((result) => {
        this.usuarios = result;
        this.usuarios.unshift({
          id: "0",
          valor: "TODOS",
        });
        this.ventasGroup.controls["usuarioCtrl"].setValue({
          id: "0",
          valor: "TODOS",
        });
        this.loadingUsuarios = false;
        this.filteredUsuarios = this.ventasGroup
          .get("usuarioCtrl")
          .valueChanges.pipe(
            startWith(""),
            map((usuario) =>
              usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
            )
          );
      });

    this.cargarInformacion(0, 0, nFecha, nFecha, this.usuarioConsulta, 1);
  }

  ngOnInit() {
    this.ruta.setRuta();
    this.dtTrigger["uno"] = new Subject<any>();
    this.dtTrigger["dos"] = new Subject<any>();
  }

  private _filterUsuarios(value: any): Usuario[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    //console.log(filterValue);
    //const filterValue = value.valor.toLowerCase();

    return this.usuarios.filter(
      (usuario) => usuario.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }

  cargarUsuariosAgencia() {
    this.loadingUsuarios = true;
    const agencia = this.ventasGroup.get("idAgencia").value;

    this.serviceUsuario
      .getUsuariosPersonas(3, this.usuarioConsulta, agencia, 0) //3 es para usuarios tipo vendedor
      .subscribe((result) => {
        this.usuarios = result;
        this.usuarios.unshift({
          id: "0",
          valor: "TODOS",
        });
        this.ventasGroup.controls["usuarioCtrl"].setValue({
          id: "0",
          valor: "TODOS",
        });
        this.loadingUsuarios = false;
        this.filteredUsuarios = this.ventasGroup
          .get("usuarioCtrl")
          .valueChanges.pipe(
            startWith(""),
            map((usuario) =>
              usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
            )
          );
      });
  }

  displayFn(usuario) {
    //console.log(JSON.stringify(usuario));
    return usuario ? usuario.valor : usuario;
  }

  cargarInformacion(
    usuario,
    agencia,
    fechaInicial,
    fechaFinal,
    idUsuarioConsulta,
    origen //origen es desde donde se carga la informacion, si es primera ejecucion o es ejecucion de filtro
  ) {
    this.loading = true;

    this.servicioRecorridoVendedor
      .getRecorridoVendedor(
        usuario,
        agencia,
        fechaInicial,
        fechaFinal,
        idUsuarioConsulta
      )
      .subscribe((data) => {
        //console.log(data);
        //return;
        this.dataRecorrido = data;
        this.loading = false;
        if (data.length > 0) {
          this.haveData = true;
        }
        this.grafica();
        this.graficaBarra();
        this.resumen();
        if (origen == 1) {
          this.dtTrigger["uno"].next();
          this.dtTrigger["dos"].next();
          setTimeout(() => {
            $("#personalizado_wrapper").hide();
          }, 100);
        } else if (origen == 2) {
          this.reRender();
        }
        this.timeRunning++;
      });
  }

  reRender() {
    let i = 0;
    //console.log(this.dtElements);
    this.dtElements.toArray().forEach((dtElement: DataTableDirective) => {
      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        // Do your stuff
        dtInstance.destroy();
      });
    });
    this.dtTrigger["uno"].next();
    this.dtTrigger["dos"].next();
    setTimeout(() => {
      $("#personalizado_wrapper").hide();
    }, 100);

    /*this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });*/
  }

  busqueda() {
    //console.log( this.ventasGroup.get('usuarioCtrl').value);
    //console.log(this.entregasGroup.get('idAgencia').value);
    //return;
    const usuarioConsulta = this.usuarioConsulta;
    const agencia = this.ventasGroup.get("idAgencia").value;
    const usuario = this.ventasGroup.get("usuarioCtrl").value;
    const fechaInicial = _moment(
      this.ventasGroup.get("fechaInicial").value,
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
    const fechaFinal = _moment(
      this.ventasGroup.get("fechaFinal").value,
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
    //const tipoConsulta = this.ventasGroup.get('tipoConsulta').value;
    //console.log(tipoConsulta);
    //return;
    this.cargarInformacion(
      usuario.id,
      agencia,
      fechaInicial,
      fechaFinal,
      usuarioConsulta,
      2
    );
  }

  verDetalle(item) {
    const dialogRef = this.dialog.open(DialogDetallePedidoComponent, {
      data: item,
      width: "100em",
      //disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      /*if (result) {
        this.refrescaBusqueda();
      }*/
      console.log("Resultado es :" + result);
    });
  }

  onHeaderClick(event, index) {}

  onDotClick(event, index) {}

  exportarExcel() {
    const fileName = "recorridoVendedor.xlsx";

    let data = JSON.parse(JSON.stringify(this.dataRecorrido));
    //let data = this.dataEntregas;

    data.forEach((element) => {
      delete element.busqueda;
    });

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "recorrido");

    XLSX.writeFile(wb, fileName);
  }

  clickMenu(event) {
    event.stopPropagation();
  }

  mostrarGrafica() {
    this.mostrarTimeLine = 2;
    this.busqueda();
  }

  fnMostrarTimeLine() {
    this.mostrarTimeLine = 1;
    this.busqueda();
  }

  mostrarResumen() {
    this.mostrarTimeLine = 3;
    this.busqueda();
  }

  mostrarTabla() {
    this.mostrarTimeLine = 4;
    this.busqueda();
  }

  grafica() {
    let labels = _.chain(this.dataRecorrido)
      .map(function (recorrido) {
        return recorrido.tipoNovedad;
      })
      .uniq()
      .value();

    let colors = [];
    let dataSetPie = [];

    let i = 0;
    labels.forEach((data) => {
      let arregloData = _.where(this.dataRecorrido, {
        tipoNovedad: data,
      });
      dataSetPie.push(arregloData.length);
      //console.log(arregloData);

      const colorServicio = this.servicioColores.getRandomColor(i);
      colors.push(colorServicio);
      i++;
    });

    //console.log(dataSetPie);
    /*let dataPie = [];

    this.recorridoBar.forEach(element => {


      const conteo = _.where(element);
    });*/

    //console.log(colors);

    let data = {
      type: "pie",
      data: {
        labels: labels,
        datasets: [
          {
            label: "Cantidad Novedades: ",
            backgroundColor: colors,
            data: dataSetPie,
          },
        ],
      },
    };

    if (this.recorridoPie) this.recorridoPie.destroy();

    let canvas: any = document.getElementById("recorridoPie");

    this.recorridoPie = new chart(canvas, data);
  }

  graficaBarra() {
    let labels = _.chain(this.dataRecorrido)
      .map(function (recorrido) {
        return recorrido.tipoNovedad;
      })
      .uniq()
      .value();

    let colors = [];
    let dataSetBarra = [];

    let i = 0;
    labels.forEach((data) => {
      let arregloData = _.where(this.dataRecorrido, {
        tipoNovedad: data,
      });
      dataSetBarra.push(arregloData.length);
      //console.log(arregloData);

      const colorServicio = this.servicioColores.getRandomColor(i);
      colors.push(colorServicio);
      i++;
    });

    let dataBar = {
      type: "bar",
      data: {
        labels: labels,
        datasets: [
          {
            label: "Cantidad Novedades: ",
            backgroundColor: colors,
            data: dataSetBarra,
          },
        ],
      },
    };

    if (this.recorridoBar) this.recorridoBar.destroy();

    let canvas: any = document.getElementById("recorridoBar");

    this.recorridoBar = new chart(canvas, dataBar);
  }

  resumen() {
    this.novedades = [];

    this.novedades = _.chain(this.dataRecorrido)
      .map(function (recorrido) {
        return recorrido.tipoNovedad;
      })
      .uniq()
      .value();

    let dataNovedades = [];
    this.valoresResumen = [];

    let i = 0;
    this.novedades.forEach((data) => {
      let arregloData = _.where(this.dataRecorrido, {
        tipoNovedad: data,
      });
      dataNovedades.push(arregloData.length);
      //console.log(arregloData);

      i++;
    });

    this.valoresResumen = dataNovedades;
    this.totalNovedades=0;
    for(i=0;i<this.valoresResumen.length;i++){
      this.totalNovedades+=this.valoresResumen[i];
    }
    /*let dataValor = _.where(this.dataRecorrido, {
      idTpoVentaNovedad:1//1 es por que es una venta efectiva
    });*/

    //console.log(dataValor);
    this.totalVenta = 0;

    this.dataRecorrido.forEach((element) => {
      //console.log(element);
      this.totalVenta += element.precio;
    });

    //this.totalVenta = dataValor.reduce((a, b) => a + b, 0)
  }
}
